<template>
<div>
	<!-- Legend for Department Coloring of Search Results -->
	<v-card v-if="legendColors.length>0 && searchResultSidebarOpen" class="legendCard">
		<v-toolbar class="legendToolbar pl-2 pr-0" color="blue lighten-4">
			<v-toolbar-title>LEGEND</v-toolbar-title>
			<v-spacer></v-spacer>
			<v-toolbar-items class="ml-5 pt-2">
				<v-tooltip left>
					<v-btn slot="activator" icon @click.stop="setLegendOpen(false)">
							<v-icon>close</v-icon>
					</v-btn>
					<span>Close</span>
				</v-tooltip>
			</v-toolbar-items>
		</v-toolbar>
		<v-card class="pl-3 py-4">
	    	<v-list>
				<v-list-tile 
		    		v-for="(item, index) in legendColors"
		    		:key="index" 
		    		class="customLegendlisttile">	
		    		<v-layout row fill-height>		        		
		        		<v-flex xs1 class="legendColorbox" 
		        				:style="{ backgroundColor: `rgb(${item.color[0]},${item.color[1]},${item.color[2]})`}">	        			
		        		</v-flex>
		        		<v-flex class="ml-4">{{ item.name }}</v-flex>
		        	</v-layout>
		        </v-list-tile>
		    </v-list>
		</v-card>
	</v-card>

	<!-- Legend for Hatching Classification -->
	<v-card v-if="hatchClassOn" class="legendCardLeft" elevation="6">
		<v-toolbar dark class="legendToolbar pl-2 pr-0" color="grey darken-4">
			<v-toolbar-title class="caption">LEGEND</v-toolbar-title>
			<v-spacer></v-spacer>
			<v-toolbar-items class="ml-5 pt-2">
				<v-tooltip left>
					<v-btn slot="activator" icon @click.stop="setLegendOpen(false)">
							<v-icon>close</v-icon>
					</v-btn>
					<span>Close</span>
				</v-tooltip>
			</v-toolbar-items>
		</v-toolbar>
		<v-list class="">
			<v-list-tile>
				<v-layout row fill-height align-center>		        		
	        		<v-flex xs2>
	        			<img width="30px" src="https://interactivefloorplans.arizona.edu/static/img/legend-diamond.png">
								      			
	        		</v-flex>
	        		<v-flex class="ml-4">Research</v-flex>
	        	</v-layout>
			</v-list-tile>
			<v-list-tile>
				<v-layout row fill-height align-center>		        		
	        		<v-flex xs2>
	        			<img width="30px" src="https://interactivefloorplans.arizona.edu/static/img/legend-triangle.png">
								       			
	        		</v-flex>
	        		<v-flex class="ml-4">Education</v-flex>
	        	</v-layout>
			</v-list-tile>
			<v-list-tile>
				<v-layout row fill-height align-center>		        		
	        		<v-flex xs2>
	        			<img width="30px" src="https://interactivefloorplans.arizona.edu/static/img/legend-dot.png">
								       			
	        		</v-flex>
	        		<v-flex class="ml-4">Administration</v-flex>
	        	</v-layout>
			</v-list-tile>
			<v-list-tile>
				<v-layout row fill-height align-center>		        		
	        		<v-flex xs2>
	        			<img width="30px" src="https://interactivefloorplans.arizona.edu/static/img/legend-outline.png">
								        			
	        		</v-flex>
	        		<v-flex class="ml-4">Room Borrowed</v-flex>
	        	</v-layout>
			</v-list-tile>
		</v-list>
	</v-card>
</div>
</template>

<script>
import Vuex from 'vuex'
import { mapState, mapMutations } from 'vuex'

export default {
	name: 'Legend',
	data () {
		return {}
	},
	
	computed: {
		...mapState({   legendColors: 				state => state.ui.legendColors,
						searchResultSidebarOpen: 	state => state.ui.searchResultSidebarOpen,
						hatchClassOn:  				state => state.colorRooms.hatchClassOn,
					}),

		items: function () {
			return this.categoryColors
		}

	},

	methods : {
		...mapMutations(['setLegendOpen',]),
	},
}

</script>


<style>

.legendCard {
	position: fixed !important;
	top: 210px;
	right: 40px;
	z-index: 0;
}

.legendCardLeft {
	position: fixed !important;
	bottom: 10px;
	left: 10px;
	z-index: 0;
}

.legendToolbar .v-toolbar__content {
	padding-left: 10px;
	padding-right: 0px !important;
}

.legendColorbox {
	width: 9px;
	height: 12px !important;
	margin-top: 6px;
	margin-left: 0px !important;
	border-style: solid;
	border-width: 1px;
	opacity: .75;
	min-width: 20px !important;
}

.customLegendlisttile > .v-list__tile {
    height: auto;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-top: 1px;
}

</style>



// WEBPACK FOOTER //
// src/components/Legend.vue